export function sortByDateArrayOp<T>(
    mappingFunc: (obj: T) => Date,
    direction: 'asc' | 'desc' = 'desc',
): (valA: T, valB: T) => number {
    return (valA, valB) => {
        const bTime = mappingFunc(valB).getTime();
        const aTime = mappingFunc(valA).getTime();

        return direction === 'asc' ? aTime - bTime : bTime - aTime;
    };
}
